import React from 'react';
// import APISettingsModel from './APISettingsModel';
import APISettingsItemsPanelView from './APISettingsItemsPanelView';
// import settingsPanelModel from './SettingsPanelModel';
import { useCardStyle } from './UdfEditor';
import SettingsModel from './SettingsModel';

export default React.memo(({ settings, classes }: { settings: SettingsModel; classes?: any }) => {
  const cardClasses = useCardStyle({ classes });
  const [, setRefresh] = React.useState(0);

  function handleRefresh() {
    if (!settings) return;
    setRefresh((tick: number) => tick + 1);
  }

  return (
    <div className={cardClasses.container}>
      <div className={cardClasses.left}>
        <APISettingsItemsPanelView settings={settings} refresh={handleRefresh} classes={cardClasses} />
      </div>
    </div>
  );
});

// requestAnimationFrame(() => {
//   const settingsModel         = new APISettingsModel();
//   settingsModel.SettingsView  = APIsSettingsView;
//   settingsPanelModel.addSettings('Settings', settingsModel);
// });
